import { FormButtonsLayout } from 'framework/ui/layout';
import { FormTemplateProps, UpdateForm } from 'framework/form';
import Box from '@mui/material/Box';
import useCandidateOfferService from 'domain/recruiting/candidate/Timeline/offer/candidateOfferService';
import { useListContext } from 'framework/list';
import { useShowContext } from 'framework/show';
import CandidateOfferListInput from '../CandidateOfferListInput';
import CandidateOfferCompensationDetailsInput from '../CandidateOfferCompensationDetailsInput';

interface CreateOfferFormProps extends FormTemplateProps {
  onCancel?: () => void;
}

const UpdateCandidateOfferForm = ({ onCancel, messageContext }: CreateOfferFormProps) => {
  const { update, getById, getValidationSchema } = useCandidateOfferService();
  const { reloadData } = useListContext();
  const { data: entity } = useShowContext();

  return (
    <UpdateForm
      messageContext={messageContext}
      getDataFunc={() => getById(entity.offerId)}
      submitFormFunc={update}
      afterSubmit={{
        execute: () => {
          if (reloadData) {
            reloadData();
          }
          if (onCancel) {
            onCancel();
          }
        },
        message: 'You are awesome! The Offer has been successfully updated.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      entityId={entity.offerId}
    >
      <CandidateOfferListInput
        isVisible
        source="compensationDetails"
        maxFields={4}
        addText="Update Compensation Details"
        inputTemplate={(props: any) => <CandidateOfferCompensationDetailsInput {...props} />}
      />

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
        <FormButtonsLayout onCancelAction={onCancel} />
      </Box>
    </UpdateForm>
  );
};

export default UpdateCandidateOfferForm;
